"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _coreBaseProps = require("@vfuk/core-base-props");
function simpleClickHandler(event, interactionHandler, dataSelectorPrefix, link) {
  var _getDataSelector;
  interactionHandler(event, (_getDataSelector = (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, link.id)) !== null && _getDataSelector !== void 0 ? _getDataSelector : '');
  if (!link.onClick) return;
  link.onClick();
}
var _default = simpleClickHandler;
exports["default"] = _default;